import { Directive } from '@angular/core';

@Directive({
  selector: 'wchfs-validation-error',
})
export class ValidationError {}
